import React, { useEffect, useState } from 'react';
import Main from '../../Main';
import { Col, Dropdown, Row } from 'react-bootstrap';
import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import '../../../assets/css/dashboard.scss'
import '../../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn, { SbAddBtn, SbFilterBtn } from '../../Buttons/Buttons';
import Select from 'react-select';
import AddFunctionalApproval from './AddFunctionalApproval';
import FunctionalApprovalTable from './FunctionalApprovalTable';
import Download from '../../MainSection/Download/Download';
import { useNavigate } from 'react-router-dom';
import FAColumnFilterModal from './FAColumnFilterModal';
import FAValueFilterModal from './FAValueFilterModal';
import { useDispatch, useSelector } from 'react-redux';
import { loadSettingsFunctionalApprovalData, loadSettingsSingleFunctionalApprovalData, postFunctionalApprovalDatas } from '../../../redux/action';
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { ADDED_BY_ID } from '../../../Constants';

const statusOptions = [
    { value: 50, label: "Active" },
    { value: 51, label: "Inactive" }
]

const FunctionalApproval = () => {


    let dispatch = useDispatch();

    const { functionalApprovalData } = useSelector((state) => state.data);
    const { singleFunctionalApprovalData } = useSelector((state) => state.data);
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const PreviousCompanyID = JSON.parse(sessionStorage.getItem('PreviousCompanyID'));

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [functionalApprovalId, setFunctionalApprovalId] = useState("");
    const [selectedColumns, setSelectedColumns] = useState([
        "APPROVAL LEVEL", "TITLE", "DEPARTMENT", "APPROVAL ORDER", "APPROVAL CONDITIONS",
        "STATUS", "ACTION"
    ]);

    const [selectedStatusID, setSelectedStatusID] = useState(null);

    const handleStatusSelection = (selectedOption) => {
        if (selectedOption) {
            const statusID = selectedOption.value;  // Extract StatusID (assuming 'value' is the StatusID)
            setSelectedStatusID(statusID);  // Store StatusID in state
            functionalApprovalDatas(statusID);  // Call API with both StatusID and current RoleID
        }
    };

    const functionalApprovalDatas = (statusID) => {
        dispatch(loadSettingsFunctionalApprovalData(setLoading, statusID))
    }

    useEffect(() => {
        functionalApprovalDatas();
    }, [])

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const handleOpenModal = (functionalApprovalID) => {
        setIsModalOpen(true);
        if (functionalApprovalID) {
            dispatch(loadSettingsSingleFunctionalApprovalData(functionalApprovalID));
            setFunctionalApprovalId(functionalApprovalID);
        } else {
            setFunctionalApprovalId("");
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }

    const handleStatusChange = (customer, statusLabel) => {
        const statusID = statusLabel === "Active" ? 50 : 51; // 50 for Active, 51 for Inactive

        // console.log(customer, 'customer')
        const data = {
            FunctionalApprovalID: customer.FunctionalApprovalID,
            LevelID: customer.FunctionalApprovalLevelID,
            Title: customer.FunctionalApprovalTitle,
            DepartmentID: customer.FunctionalApprovalDepartmentID,
            Order: customer.FunctionalApprovalOrder,
            Condition: customer.FunctionalApprovalCondition,
            StatusID: statusID,
            AddedByID: ADDED_BY_ID
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        // Dispatch the action to update the department status
        dispatch(postFunctionalApprovalDatas(requestOption, handleCloseModal, functionalApprovalDatas, customer.FunctionalApprovalID));
        // console.log(data, 'data'); // For debugging purposes
    };

    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };

    const handleClearFilters = () => {
        setSelectedStatusID(null);
        functionalApprovalDatas();
    }

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Settings / Functional Approval"
                        onBackClick={handleBack}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Functional Approval</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={3} className='filters-col'>
                                    <Select
                                        className="react-select-container complaint-status-select"
                                        classNamePrefix="react-select"
                                        placeholder="Search Status"
                                        options={statusOptions}
                                        style={{ width: "100%" }}
                                        value={selectedStatusID ? statusOptions.find(status => status.value === selectedStatusID) : null}
                                        onChange={(selectedOption) => handleStatusSelection(selectedOption)}
                                    />
                                </Col>
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                {(signInDetails[0]?.SignInType !== 'ClientAdmin' || PreviousCompanyID) && <SbAddBtn btnName="Add" onClickEffect={() => { handleOpenModal("") }} />}
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <FunctionalApprovalTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                loading={loading}
                                functionalApprovalData={functionalApprovalData}
                                handleStatusChange={handleStatusChange}
                                selectedColumns={selectedColumns}
                                signInDetails={signInDetails}
                                PreviousCompanyID={PreviousCompanyID}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddFunctionalApproval
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    functionalApprovalDatas={functionalApprovalDatas}
                    singleFunctionalApprovalData={singleFunctionalApprovalData}
                    functionalApprovalId={functionalApprovalId}
                />
            }
            {showColumnFilterModal && (
                <FAColumnFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                    selectedColumns={selectedColumns}
                    handleSaveColumns={handleColumnSelectionChange}
                />
            )}
            {showValueFilterModal && (
                <FAValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )}
            {/* {showCustomerViewDetails && (
                <CustomerViewDetails
                    showCustomerViewDetails={showCustomerViewDetails}
                    handleCloseViewDetails={handleCloseViewDetails}
                />
            )} */}
        </div >
    );
};

export default FunctionalApproval;